import { Component, Input, OnInit, AfterViewInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit, AfterViewInit {

  @Input() state:string = "";
  @Input() disabled?:string;

  constructor(el: ElementRef) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if(this.disabled == "true") {
      let classDisabled = document.querySelectorAll(".ant-select-disabled")
      classDisabled.forEach((element:any) => {
        element.classList.add("fill")
      });
    }
    
  }

}
